import React from 'react'
import DashboardLayout from '../../components/layouts/DashboardLayout'
import InvoiceComponent from '../../components/invoices/InvoiceComponent'

const Invoice = () => {
  return (
   <DashboardLayout>
     <InvoiceComponent />
   </DashboardLayout>
  )
}

export default Invoice